"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getClusterAgentByOutPoint = void 0;
const lumos_1 = require("@ckb-lumos/lumos");
const helpers_1 = require("../../../helpers");
const config_1 = require("../../../config");
async function getClusterAgentByOutPoint(outPoint, config) {
    // Env
    config = config ?? (0, config_1.getSporeConfig)();
    const rpc = new lumos_1.RPC(config.ckbNodeUrl);
    // Get cell from rpc
    const cellWithStatus = await (0, helpers_1.getCellWithStatusByOutPoint)({
        outPoint,
        rpc,
    });
    if (!cellWithStatus.cell) {
        throw new Error('Cannot find ClusterAgent by OutPoint because target cell was not found');
    }
    if (cellWithStatus.status !== 'live') {
        throw new Error('Cannot find ClusterAgent by OutPoint because target cell is not lived');
    }
    // Check target cell's type script
    const cellType = cellWithStatus.cell.cellOutput.type;
    if (!cellType || !(0, config_1.isSporeScriptSupported)(config, cellType, 'ClusterAgent')) {
        throw new Error('Cannot find ClusterAgent by OutPoint because target cell is not a supported version of ClusterAgent');
    }
    return cellWithStatus.cell;
}
exports.getClusterAgentByOutPoint = getClusterAgentByOutPoint;
//# sourceMappingURL=getClusterAgent.js.map